import { render } from "./Footer.vue?vue&type=template&id=786d8563&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=786d8563&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786d8563"]])

export default __exports__